import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentProfile, clearProfile, cleargid, getTFCgrievances, getProfileById } from '../../actions/profile';
import { getProfileAdmin } from '../../actions/master';
import { TFC_CENTER } from '../../Constant';

import moment from 'moment';

const ReportTFC = ({
  getCurrentProfile, getTFCgrievances, getProfileAdmin, getProfileById,
  clearProfile,
  auth: { user },
  profile: { profile, profile3, gt },
  history
}) => {

  const [formData, setFormData] = useState({
    stfc: '39', ntfc: 'Govt. Polytechnic College, Kilapalur Village, Ariyalur – 621 707.', comment: '', appln: '', sgid: '', sgt: ''
  });

  const { stfc, ntfc, comment, appln, sgid, sgt } = formData;
  const [displaycmts, toggledisplaycmts] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // if there is no profile, attempt to fetch one
    //if (profile !== null && profile._aid !== null)
    if(profile3 === null)
        getTFCgrievances(user.tfccode);    
    // else
    //   navigate("/dashboard");
    
  }, [getTFCgrievances, profile3]);

  const handleSelectRow = async (i,aid,sgt) => {
    toggledisplaycmts(!displaycmts);
    console.log(i,aid);
    formData.appln = aid;
    formData.sgid = i;
    formData.sgt = sgt;
    await getProfileById(formData.appln, formData.sgid);
    navigate("/upload2");
  }

  const handleEditRow = async (i,aid,sgt) => {    
    console.log(i,aid);
    formData.appln = aid;
    formData.sgid = i;
    formData.sgt = sgt;
    await getProfileAdmin(formData.appln, formData.sgt, history);           
    navigate("/adash");
  }



  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });


  const responses = profile3 !== null && profile3 !== undefined && profile3.gr !== undefined && profile3.cmts !== undefined && profile3.cmts.length > 0 && profile3.cmts.map((comment) => (
    <tr key={comment._id}>
        <td>{comment.rep}</td>  
              
    </tr>
  ));

  function checkelement(arr, gid) {
    console.log(arr, gid);
    const isObjectPresent = arr.find((o) => o.gid === gid);
    console.log(isObjectPresent);
    if (!isObjectPresent) {  return false; }
    
    return true;
  }
  var chk = null;

  const grievances = profile3 !== null && profile3 !== undefined && profile3.map((edu, i) => (
    <tr key={i}>
        <td>{i+1}</td>
      <td>{edu._aid}</td>   
      <td>
      {edu.gr.map((pp,k) => (
        <div className='table-responsive-sm'>
        <table className='table table-striped table-bordered table-hover table-condensed' style={{border: '1px ridge', textAlign: "center"}}> <tbody>
        <tr key={k}>          
          <td style={{width:"16.6%"}}>{pp.gt}</td>      
          {pp.st.toString() === "closed" && <td style={{color: "crimson", width:"16.6%"}}> {pp.st} </td> }
          {pp.st.toString() === "open" && <td style={{color: "blue", width:"16.6%"}}> {pp.st} </td> }
          <td style={{width:"16.6%"}}> {moment(pp.d).format('DD/MM/YYYY')} </td>
          <td style={{width:"16.6%"}}>
          {((edu.gups !== undefined && edu.gups !== null) && edu.gups.filter((item => (item._gid === pp._gid)))).map((chk,lp) => (
            <a key={lp} href={chk.l} target="_blank" rel="noopener noreferrer" > Download </a>
          ))}
          </td>   
         
         

          <td style={{width:"16.6%"}}>
            {((edu.cmts !== undefined && edu.cmts !== null) ? (edu.cmts.filter((item => (item._gid === pp._gid)))).map((chk,op) => (
              <div key={op}> {chk.rep} </div>
            )): <td style={{width:"16.6%"}}></td>)}
          </td>               
          {pp.st !== undefined && pp.st.toString() === "closed" ? (
            <td style={{width:"16.6%"}}> {pp.ct.n} - {pp.ct.m} - {pp.ct.rel}</td>): <td style={{width:"16.6%"}}>-</td>
          }

        </tr>  </tbody>
        </table>
        </div>
      ))}
      </td>
    </tr>
  ));

  const clearNext = async() => {
    //clearProfile(history, "3");   
    await clearProfile();
    await getTFCgrievances(formData.stfc);
  }

  return (
    <section className="container">
      {/* <h1 className="large text-primary">{user.tfcname}</h1> */}

      <h4><i className="fas fa-list" /> Grievances Report </h4>
        <div style={{color: 'crimson' }}> Please raise all grievances with request letter. <br/> Any Grievance will be processed only if request letter along with proof is uploaded.
        </div>
        <br/>
        <h5 style={{color: 'blue' }}> Kindly delete the grievances without request letter. Add new grievance after request letter is received from the candidate.
        </h5>

        {profile3 !== null && profile3 !== undefined && 
      <>

          <div className=''>
          <table className="table" style={{border: '1px ridge', textAlign: "center"}}>
            <thead>
              <tr >
              <th>Sl. No</th>
                <th>Application number</th>
               
                  <td>
                <table className="table" >
                  <thead>
               <tr>
                <th style={{width:"16.6%"}}>Grievance Description </th>

                <th style={{width:"16.6%"}}>Status</th>

                <th style={{width:"16.6%"}}>Date</th>                
                <th style={{width:"16.6%"}}>Request Letter</th>
                
                <th style={{width:"16.6%"}}>Admin response</th>
                <th style={{width:"16.6%"}}>Contact details</th>
                </tr>
                      
                
                </thead>
                </table>
                </td>
                </tr>
                
             
            </thead>
            <tbody>{grievances}</tbody>
          </table>
          </div>
      </>
      }      


    </section>
  );
};

ReportTFC.propTypes = {
  getCurrentProfile: PropTypes.func.isRequired,
  getTFCgrievances: PropTypes.func.isRequired,
  getProfileAdmin: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,

  clearProfile: PropTypes.func.isRequired,
  cleargid: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(mapStateToProps, { getCurrentProfile, clearProfile, cleargid, getTFCgrievances,
getProfileAdmin, getProfileById })(
  ReportTFC
);
